import { Fragment, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import styled from 'styled-components';
import Editor from './Partials/Editor';

const StyledPanel = styled.div`
	background: white;
	bottom: 0;
	color: black;
	padding: 0.618rem 0;
	position: fixed;
	width: 100%;

	#slp-cookieConsent-buttons {
		display: flex;
		justify-content: center;
		gap: 1rem;
	}
`;

const cookieName = 'slp-cookie-consent-granted';

export default function CookieConsent({
	isPreview = false,
	cookieConsentMessage,
	GoogleAnalytics = '',
	FacebookPixel = '',
}) {
	const [showBanner, setShowBanner] = useState(
		'undefined' === typeof Cookies.get(cookieName) ? true : false,
	);

	const { __ } = wp.i18n;

	useEffect(function () {
		const consentGranted = !!parseInt(Cookies.get(cookieName)) || false;
		if (consentGranted) {
			accept();
		}
	}, []);

	function accept() {
		if (isPreview) {
			return false;
		}

		if (GoogleAnalytics.length > 0) {
			gtag('consent', 'update', {
				ad_storage: 'granted',
				analytics_storage: 'granted',
			});
		}

		if (FacebookPixel.length > 0) {
			fbq('consent', 'grant');
		}

		Cookies.set(cookieName, 1, { expires: 30 });

		setShowBanner(false);
	}

	function reject() {
		if (isPreview) {
			return false;
		}

		Cookies.set(cookieName, 0, { expires: 30 });
		setShowBanner(false);
	}

	return (
		<Fragment>
			{showBanner && (
				<StyledPanel id="slp-cookieConsent">
					<div className="container">
						<Editor content={cookieConsentMessage} />
						<div id="slp-cookieConsent-buttons">
							<span onClick={accept} className="btn btn-outline-success">
								{__('Accept', 'social-link-pages')}
							</span>
							<span onClick={reject} className="btn btn-outline-danger">
								{__('Decline', 'social-link-pages')}
							</span>
						</div>
					</div>
				</StyledPanel>
			)}
		</Fragment>
	);
}
